import React from 'react';

export const SEARCH_ITEM_LOGO_SIZE = 40;

interface FallbackLogoSVGProps {
  letter: string;
  size?: number;
  shape?: 'square' | 'circle';
}

export const FallbackLogoSVG = ({ letter, shape = 'square', size = SEARCH_ITEM_LOGO_SIZE }: FallbackLogoSVGProps) => {
  const radius = shape === 'circle' ? size / 2 : 4;
  return (
    <svg
      fill="none"
      height={size}
      style={{ borderRadius: radius, display: 'block', flexShrink: 0, overflow: 'hidden' }}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#024A7A" height={size} rx={radius} width={size} />
      <text
        dominantBaseline="central"
        fill="#FFFFFF"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize={Math.round(size * 0.55)}
        fontWeight={600}
        textAnchor="middle"
        x="50%"
        y="50%"
      >
        {letter}
      </text>
    </svg>
  );
};
